const translations = {
    modalText: 'This feature is available for QuickBooks® connected customers only',
    modalTitle: 'Customer Not Supported',
    productUsageReportDeleteWarning:
        "You can't delete a work order with a product usage report attached"
};

export default translations;
